module.exports = __webpack_public_path__ + "static/img/play.603f0b23.png";